<section class="w-full border-b-2 border-primary-500">

    @if(view.site?.id != 79) {
        <app-banner_section-type01 [options]="{ title: '', imageHref:view.imageHrefs }"></app-banner_section-type01>
    }
    @if(view.site?.id === 74 || view.site?.id === 96) {
      <app-banner_section-type02 [imageHref]="this.view.imageLayer1" [title]="''"></app-banner_section-type02>
    }

    @if(view.page && view.site?.id === 79) {
        <!-- Header image with smooth flowing bottom -->
        <div class="relative w-screen h-[600px] overflow-hidden">
            <!-- Layer 1 -->
            <img [src]="view.imageLayer1" alt="Slideshow Image"
                class="absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-1000"
                [class.opacity-0]="view.activeLayer !== 1" [class.opacity-100]="view.activeLayer === 1" />
    
            <!-- Layer 2 -->
            <img [src]="view.imageLayer2" alt="Slideshow Image"
                class="absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-1000"
                [class.opacity-0]="view.activeLayer !== 2" [class.opacity-100]="view.activeLayer === 2" />
    
            <!-- Flowing wave SVG cut -->
            <svg viewBox="0 0 1440 100" preserveAspectRatio="none" class="absolute bottom-0 left-0 w-full h-[80px] block">
                <path d="M0,0 C360,100 1080,0 1440,80 L1440,100 L0,100 Z" fill="white" />
            </svg>
        </div>
    }

    <!-- <app-banner_section-type01 [options]="{ title: '', imageHref:view.imageHref  }"></app-banner_section-type01> -->

    <!-- Team Header (Title/Tagline) section -->
    @if(view.site?.id != 79) {
    <div class="bg-white">
        <div class="mb-8 flex flex-col items-center justify-center text-center">
            <!-- <h4 class="text-base text-primry-600 font-semibold tracking-wide uppercase">Our Promotional Section</h4> -->
            <p class="mt-2 text-5xl lg:text-7xl font-light font-primary tracking-wide text-gray-900 dark:text-gray-200">
                The Travel Experts
            </p>
        </div>
        <div class="flex flex-col justify-center">
            <p class="text-center text-xl md:text-2xl mb-15 max-w-lh">Our Consultants pride themselves with dedication,
                passion and
                team work. Their fast pace and attention to detail make them experts.</p>

                <!-- <h1 class="text-3xl text-center mb-15">Coming Soon!!</h1> -->
        </div>
    </div>
    }
    <!-- Team Header (Title/Tagline) section -->
    @if(view.site?.id === 79) {
    <div class="flex flex-col items-center bg-white">
        <!-- Centered image -->
        <div class="flex justify-center w-full">
            <img src="/assets/images/sections/ST MEET THE TEAM.png" class="w-100"
                alt="meet the team header image">
        </div>
    
        <!-- Centered paragraphs container -->
        <div class="max-w-4xl w-full flex flex-col items-center px-4 py-6">
            <p class="text-center text-md md:text-lg mb-6 w-full" [innerHTML]="view.page?.content.rawContent"></p>
            <p class="text-center text-md md:text-lg mb-6 w-full" [innerHTML]="view.page?.content.rawContentShort"></p>
        </div>
    </div>
    
    }

    @if(view.site?.id === 82) {
    <div class="shadow-lg pb-6 justify-center text-center flex h-full">
        <div class="grid md:grid-cols-3 gap-16">
            <div *ngFor="let member of teamMembersWB" class="space-y-4">
                <a href="#" target="_blank" class="space-y-4">
                    <img [src]="member.img" alt="{{ member.name }}"
                        class="mx-auto h-40 w-40 rounded-full xl:w-56 xl:h-56">

                    <h3 class="font-medium text-2xl text-center">
                        {{ member.name }} {{ member.lastName }}
                    </h3>
                </a>
                <div class="mt-auto">
                    <button (click)="sendEmail(member.email)"
                        class="mt-4 px-4 py-2 bg-accent-500 text-white rounded-lg hover:bg-primary-100 cursor-pointer hover:text-primary-500 transition-all duration-300">Email
                        me</button>
                </div>

            </div>
        </div>
    </div>
    }
    @if(view.site?.id === 72) {
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6 bg-gray-50 dark:bg-gray-900">
        <div class="max-w-xl mx-auto bg-gray-100 dark:bg-gray-800 p-6 rounded-lg shadow-md text-center sm:text-left"
            *ngFor="let member of teamMembersTTP">
            <div class="flex flex-col sm:flex-row items-center gap-4">
                <img [src]="member.img" alt="{{ member.name }}" class="w-28 h-28 rounded-full object-cover object-top" />
                <div>
                    <h1 class="text-lg font-semibold text-gray-800 dark:text-white">{{ member.name }} {{ member.lastName
                        }}</h1>
                    <p class="text-sm text-gray-500 dark:text-gray-400">{{ member.title }}</p>
                </div>
            </div>
            <p class="mt-4 text-gray-700 dark:text-gray-300 text-sm sm:text-base leading-relaxed">
                {{ member.about }}
            </p>
        </div>
    </div>
    }
    @if(view.site?.id === 87) {
    <div class="shadow-lg pb-6 justify-center text-center flex h-full">
        <div class="grid md:grid-cols-3 gap-16">
            <div *ngFor="let member of teamMembersWV" class="space-y-4">
                <div class="space-y-4">
                    <!-- <img [src]="member.img" alt="{{ member.name }}" class="mx-auto h-40 w-40 rounded-full xl:w-56 xl:h-56"> -->
                    <h3 class="font-medium text-2xl text-center">{{ member.name }} {{ member.lastName }}</h3>
                    <p class="italic">{{member.title}}</p>
                </div>
                <div class="mt-auto">
                    <button (click)="sendEmail(member.email)"
                        class="mt-4 px-4 py-2 bg-accent-500 text-white rounded-lg hover:bg-primary-100 cursor-pointer hover:text-primary-500 transition-all duration-300">Email
                        me</button>
                </div>

            </div>
        </div>
    </div>
    }
    @if(view.site?.id === 83) {
    <div class="shadow-lg py-6 px-8 justify-center text-center flex h-full">
        <div class="grid md:grid-cols-3 gap-16">
            <div *ngFor="let member of teamMembersBBT" class="space-y-4 bg-white rounded-xl p-3">
                <div class="space-y-4">
                    <h3 class="font-semibold text-2xl text-center">{{ member.name }} {{ member.lastName }}</h3>
                    <p class="italic">{{member.about}}</p>
                </div>
            </div>
        </div>
    </div>
    }
    @if(view.site?.id === 79) {
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6 bg-white dark:bg-gray-900">
        <div class="max-w-xl mx-auto bg-gray-100 dark:bg-gray-800 p-6 rounded-lg shadow-md text-center sm:text-left"
            *ngFor="let member of teamMembersST">
            <div class="flex flex-col sm:flex-row items-center gap-4">
                <img [src]="member.img" alt="{{ member.name }}"
                    class="w-28 h-28 md:w-36 md:h-36 lg:h-56 lg:w-56 rounded-full object-cover object-top" />
                <div class="flex flex-col">
                    <h1 class="text-lg font-semibold text-gray-800 dark:text-white">{{ member.name }}</h1>
                    <h1 class="text-lg font-semibold text-gray-800 dark:text-white">{{ member.lastName}}</h1>
                    <p class="text-sm text-gray-500 dark:text-gray-400">{{ member.title }}</p>
                </div>
            </div>
            <p class="mt-4 text-primary-500 dark:text-gray-300 text-lg italic">{{ member.tagline }}</p>
            <p class="mt-1 text-gray-500 dark:text-gray-300 text-md">{{ member.about }}</p>
            <p class="mt-4 text-primary-500 dark:text-gray-300 text-lg italic">{{ member.taglineExtend }}</p>
            <p class="mt-1 text-gray-500 dark:text-gray-300 text-md">{{ member.aboutExtend }}</p>
        </div>
    </div>
    }
    @if(view.site?.id === 75) {
    <div class="px-6 justify-center text-center flex h-full">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div class="w-full rounded-lg shadow-xl overflow-hidden flex flex-col md:flex-row mb-10"
                *ngFor="let member of teamMembersHT">
                <div class="w-full md:w-2/5 h-auto md:h-96 bg-white">
                    <img class="w-full h-auto md:h-full object-top md:object-cover" [src]="member.img" alt="{{ member.name }}">
                </div>
                <div class="w-full md:w-3/5 text-left p-6 md:p-4 bg-gray-100 space-y-2">
                    <p class="text-xl font-bold">{{member.name}}</p>
                    <p class="text-base md:text-sm leading-relaxed font-normal">{{member.about}}</p>
                </div>
            </div>
        </div>
    </div>
    }
    @if(view.site?.id === 76) {
    <div class="px-6 justify-center text-center flex h-full">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div class="w-full rounded-lg shadow-xl overflow-hidden flex flex-col md:flex-row mb-10"
                *ngFor="let member of teamMembersSW">
                <div class="w-full md:w-2/5 h-90">
                    <img class="object-top object-cover w-full h-full" [src]="member.img" alt="{{ member.name }}">
                </div>
                <div class="w-full md:w-3/5 text-left p-6 md:p-4 bg-gray-100 space-y-2">
                    <p class="text-xl tracking-wider font-bold">{{member.name}} {{member.lastName}}</p>
                    <p class="text-lg tracking-wide italic">{{member.title}}</p>
                    <p class="text-md leading-relaxed font-normal">{{member.about}}</p>
                </div>
            </div>
        </div>
    </div>
    }
</section>
